import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';
import Loader from 'Component/Loader';
import { FieldOptionsType } from 'Type/Field.type';

import './FieldPostcodeCity.style';

/** @namespace PeggysagePwa/Component/FieldPostcodeCity/Component */
export class FieldPostcodeCityComponent extends PureComponent {
    static propTypes = {
        postcodeValue: PropTypes.string.isRequired,
        cityOptions: FieldOptionsType.isRequired,
        cityValue: PropTypes.string.isRequired,
        isLoadingSuggestions: PropTypes.bool.isRequired,
        postcodeLength: PropTypes.number,
        hasNoResult: PropTypes.bool.isRequired,
        onPostcodeChange: PropTypes.func.isRequired,
        onCityChange: PropTypes.func.isRequired,
        validatePostcodeField: PropTypes.func.isRequired
    };

    static defaultProps = {
        postcodeLength: null
    };

    renderPostcodeField() {
        const {
            postcodeValue,
            postcodeLength,
            onPostcodeChange,
            validatePostcodeField
        } = this.props;

        return (
            <div block="FieldPostcodeCity" elem="PostcodeField">
                <Field
                  type={ FIELD_TYPE.text }
                  label={ __('Zip / Postal code') }
                  attr={ {
                      id: 'postcode',
                      name: 'postcode',
                      value: postcodeValue,
                      // defaultValue: postcode,
                      placeholder: __('Zip / Postal code'),
                      maxLength: postcodeLength
                  } }
                  events={ {
                      onChange: onPostcodeChange
                  } }
                  validateOn={ ['onChange'] }
                  validationRule={ {
                      // inputType: VALIDATION_INPUT_TYPE_NUMBER.numeric,
                      isRequired: true,
                      match: validatePostcodeField
                  } }
                  addRequiredTag
                />
            </div>
        );
    }

    renderCityField() {
        const {
            cityOptions, cityValue, isLoadingSuggestions, onCityChange
        } = this.props;

        const hasPlaceholder = cityOptions.length > 1;

        return (
            <div block="FieldPostcodeCity" elem="CityField">
                <Field
                  type={ FIELD_TYPE.select }
                  label={ __('City') }
                  attr={ {
                      id: 'city',
                      name: 'city',
                      noPlaceholder: !hasPlaceholder,
                      selectPlaceholder: hasPlaceholder ? '...' : null,
                      value: cityValue
                  } }
                  options={ cityOptions }
                  events={ {
                      onChange: onCityChange
                  } }
                  validateOn={ ['onChange'] }
                  validationRule={ {
                      isRequired: true
                  } }
                  addRequiredTag
                />
                <Loader isLoading={ isLoadingSuggestions } />
            </div>
        );
    }

    renderNoResultMessage() {
        const { hasNoResult } = this.props;

        if (!hasNoResult) {
            return null;
        }

        return (
            <div block="FieldPostcodeCity" elem="NoResultMsg">
                <div block="Field" elem="ErrorMessages">
                    <div block="Field" elem="ErrorMessage">
                        { __('La livraison n\'est pas disponible pour ce code postal.') }
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { hasNoResult } = this.props;

        return (
            <div block="FieldPostcodeCity" mods={ { hasNoResult } }>
                { this.renderPostcodeField() }
                { this.renderCityField() }
                { this.renderNoResultMessage() }
            </div>
        );
    }
}

export default FieldPostcodeCityComponent;
